<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="$route.params.groupId != 0 ? groupBreadcrumb : cohortBreadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-12">
                    <registration
                        :registration="registration">
                    </registration>
                    <tabs class="tabs"
                            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-3"
                            tabContentClasses="">

                        <tab-pane class="mb-0" id="instructor-issues">
                            <span slot="title">
                                {{ $t('issues.instructor-issues') }}
                            </span>
                            <issues
                                :registration="registration"
                                :simulations="simulations"
                                role="instructor">
                            </issues>
                        </tab-pane>

                        <tab-pane class="mb-0" id="pilot-issues">
                            <span slot="title">
                                {{ $t('issues.pilot-issues') }}
                            </span>
                            <issues
                                :registration="registration"
                                :simulations="simulations"
                                role="pilot">
                            </issues>
                        </tab-pane>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Registration from './registration/Registration'
    import Issues from './registration/RegistrationIssues'

    export default {

        components: {
            Registration, Issues
        },

        data() {
            return {
                registration: null,
                simulations: null,
            }
        },

        computed: {

            groupBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.$t('common.issues'),
                    },
                ]
            },

            cohortBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.$t('common.issues'),
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/data')
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.included.registration
                    vm.simulations = resp.data.included.simulations
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
